export const ConcernDescriptions = [
  { id: "dark_circle", key: "dark_circle", text: "Txt779" },
  { id: "skin_dullness", key: "skin_dullness", text: "Txt789" },
  { id: "dark_spots", key: "dark_spots", text: "Txt754" },
  { id: "acne", key: "acne" },
  { id: "uneven_skin", key: "uneven_skin", text: "Txt968" },
  { id: "face_wrinkles", key: "face_wrinkles", text: "Txt774" },
  { id: "eye_wrinkles", key: "eye_wrinkles", text: "Txt784" },
  { id: "crows_feet", key: "crows_feet", text: "Txt794" },
  { id: "redness", key: "redness" },
  { id: "pigmentation", key: "pigmentation", text: "Txt1001" },
  { id: "firmness", key: "firmness", text: "Txt764" },
  { id: "smoothness", key: "smoothness", text: "Txt964"},
  { id: "hydration", key: "hydration", text: "Txt759" },
  { id: "texture", key: "texture", text: "Txt799" },
  { id: "oxygen", key: "oxygen" },
  { id: "shine", key: "shine", text: "Txt965" },
  { id: "dryness", key: "dryness", text: "Txt1011" }
];